import React, {
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import {
  Box,
  Flex,
  Input,
  InputGroup,
  InputRightElement,
  Table,
  TableContainer,
  Tbody,
  Td,
  Text,
  Thead,
  Tr,
  HStack,
  Img,
  Button,
  Image,
  MenuItem,
  MenuList,
  MenuButton,
  Menu,
  useDisclosure,
  Skeleton,
} from "@chakra-ui/react";
import { SearchIcon } from "@chakra-ui/icons";
import { formatTableValue } from "./formatTable";
import chevronLeft from "../../assets/images/employee/chevron-left.svg";
import chevronRight from "../../assets/images/employee/chevron-right.svg";
import useDebounce from "../../hooks/useDebounce";
import ReactPaginate from "react-paginate";
import calendarIcon from "../../assets/images/onleave/calendar.svg";
import iconEdit from "../../assets/images/product/edit.svg";
import iconAdd from "../../assets/images/booking/plus-square.svg";
import icontrash from "../../assets/images/product/trash.svg";
import { AiOutlineMore } from "react-icons/ai";
import DeleteDialog from "../../components/dialog/delete";
import AddBooking from "./formBooking/addBooking";
import AddProduct from "./formBooking/addProduct";
import SearchableSelect from "../../components/selectForm";
import DatePicker from "react-datepicker";
import { useBookingEvent } from "../../hooks/useBookingEvent";
import { useCategories } from "../../categorys/booking/index";
import toast from "react-hot-toast";
import { bookingEventCall } from "../../api/bookingEvent";
import { apartmentBookingEventLinkCall } from "../../api/apartmentBookingEventLink";
import SearchableSelectMulti from "../../components/selectForm/mutiSelect";

const TableApartments = ({ isRefetchingWithCreate, paramData }) => {
  const { isOpen, onOpen, onClose, onToggle } = useDisclosure();
  // table
  const [dateRange, setDateRange] = useState([null, null]);
  const [startDate, endDate] = dateRange;
  const [search, setSearch] = useState("");
  const [dataEdit, setDataEdit] = useState(null);
  const [popupDelete, setPopupDelete] = useState(false);
  const [isAddBooking, setIsAddBooking] = useState(false);
  const [projectId, setProjectId] = useState([]);
  const [shouldFetch, setShouldFetch] = useState(false);

  const debouncedSearchTerm = useDebounce(search, 500);
  const onChangeSearch = useCallback((e) => {
    const { value } = e.target;
    setSearch(value);
  });

  const {
    bookingEventData,
    refetch,
    isLoading,
    isRefetching,
    totalPages,
    setCurrentPage,
    currentPage,
    entries,
    startEntry,
    endEntry,
  } = useBookingEvent(debouncedSearchTerm, startDate, endDate, projectId);

  // refech create
  function usePrevious(value) {
    const ref = useRef();
    useEffect(() => {
      ref.current = value;
    }, [value]);
    return ref.current;
  }
  const prevIsRefetchingWithCreate = usePrevious(isRefetchingWithCreate);

  useEffect(() => {
    if (
      isRefetchingWithCreate &&
      prevIsRefetchingWithCreate !== isRefetchingWithCreate
    ) {
      refetch();
    }
  }, [isRefetchingWithCreate, prevIsRefetchingWithCreate, refetch]);

  useEffect(() => {
    paramData({
      search: debouncedSearchTerm,
      startDate,
      endDate,
      projectId,
    });
  }, [debouncedSearchTerm, startDate, endDate, projectId]);

  useEffect(() => {
    const timer = setTimeout(() => {
      setShouldFetch(true);
    }, 1200);

    return () => clearTimeout(timer);
  }, []);

  const { constantData } = useCategories(shouldFetch);

  const formatEntries = (entries) =>
    Object.entries(entries || {}).map(([key, value]) => ({ key, value }));

  const projects = useMemo(
    () => formatEntries(constantData?.project),
    [constantData?.project]
  );

  const tableData = {
    headers: [
      {
        label: "",
        key: "",
      },
      {
        label: "MĐNBK",
        key: "code",
      },
      {
        label: "Tên đợt booking",
        key: "name",
      },
      {
        label: "Tên dự án",
        key: "project",
      },
      {
        label: "Số sản phẩm",
        key: "product",
      },
      {
        label: "TG bắt đầu",
        key: "startTime",
      },
      {
        label: "TG kết thúc",
        key: "endTime",
      },
      {
        label: "Số tiền booking",
        key: "price",
      },
      {
        label: "Nhân viên tạo",
        key: "creator",
      },
      // {
      //   label: "Ngày tạo",
      //   key: "createdAt",
      // },
    ],
    data: bookingEventData,
  };

  const handlePageChange = (selectedPage) => {
    setPopupDelete(false);
    setCurrentPage(selectedPage.selected + 1);
    refetch();
  };

  const handlePopupDelete = (e) => {
    setDataEdit(e?.edit);
    setPopupDelete(true);
    onOpen();
  };

  const handlePopup = (type, e) => {
    setIsAddBooking(type);
    setPopupDelete(false);
    setDataEdit(e?.edit);
    onOpen();
  };

  const handlePopupAddProduct = (type, e) => {
    setIsAddBooking(type);
    setPopupDelete(false);
    setDataEdit(e?.addProduct);
    onOpen();
  };

  const onSubmitEdit = async (data) => {
    const toastCreate = toast.loading("Đang sửa đợt nhận booking ...");
    try {
      const { id, ...dataEdit } = data;
      await bookingEventCall.update(id, dataEdit);

      await refetch();
      onToggle();
      onClose();
      toast.success("Sửa thành công");
    } catch (error) {
      console.log({ error });
      toast.dismiss(toastCreate);
    }
    toast.dismiss(toastCreate);
  };

  const onSubmitDelete = async () => {
    const toastEdit = toast.loading("Đang xóa dữ liệu ...");
    try {
      const { id } = dataEdit;
      await bookingEventCall.delete(id);
      await refetch();
      setDataEdit(null);
      onClose();
      toast.success("Xóa thành công");
    } catch (error) {
      console.error("Error:", error);
      toast.error("Có lỗi xảy ra khi xóa");
    }
    toast.dismiss(toastEdit);
  };

  const addProductBookingEvent = async (data) => {
    const toastCreate = toast.loading(
      "Đang thêm sản phẩm vào đợt nhận booking ..."
    );
    try {
      await apartmentBookingEventLinkCall.create(data);

      await refetch();
      onToggle();
      onClose();
      toast.success("Thêm thành công");
    } catch (error) {
      console.log({ error });
      toast.dismiss(toastCreate);
    }
    toast.dismiss(toastCreate);
  };

  return (
    <>
      <Flex flexDirection={"column"} gap={{ base: "16px" }}>
        <Flex
          backgroundColor="var(--color-main)"
          borderRadius={{ base: "12px" }}
          flexDirection={"column"}
        >
          <Flex
            alignItems={"center"}
            justifyContent={"space-between"}
            gap={{ base: "32px" }}
            p={"16px 16px 12px 16px"}
          >
            <Flex
              alignItems={"flex-start"}
              gap={{ base: "16px 32px" }}
              flex={"1"}
              flexDirection={"column"}
            >
              <InputGroup
                maxW="42vw"
                minW={"42vw"}
                borderRadius={{ base: "8px" }}
                w={{ base: "100%" }}
              >
                <Input
                  placeholder="Nhập tên đợt nhận booking..."
                  type="text"
                  borderRadius={{ base: "8px" }}
                  border={{ base: "1px solid var(--color-boder)" }}
                  onChange={onChangeSearch}
                />
                {/* <InputRightElement
                  borderTopRightRadius={"8px"}
                  borderBottomRightRadius={"8px"}
                  pointerEvents="none"
                  bg="var(--color-boder)"
                  cursor={"pointer"}
                >
                  <SearchIcon color="var(--color-black)" />
                </InputRightElement> */}
                <InputRightElement
                  borderTopRightRadius={"8px"}
                  borderBottomRightRadius={"8px"}
                  pointerEvents="none"
                  cursor={"pointer"}
                  backgroundImage="var(--color-button)"
                >
                  <SearchIcon color="var(--color-main)" />
                </InputRightElement>
              </InputGroup>
              <Flex
                alignItems={"center"}
                gap={{ base: "16px 32px" }}
                flex={"1"}
                flexWrap={"wrap"}
                w={"100%"}
              >
                <InputGroup w={"100%"} maxW={"255px"} zIndex={3}>
                  <DatePicker
                    selectsRange={true}
                    startDate={startDate}
                    endDate={endDate}
                    dateFormat="dd/MM/yyyy"
                    locale="vi"
                    onChange={(update) => {
                      setDateRange(update);
                    }}
                    isClearable={true}
                    placeholderText="Từ ngày - Đến ngày"
                    className="datePickerStyle"
                  />
                  {!startDate && !endDate && (
                    <InputRightElement pointerEvents="none" h={"44px"}>
                      <Image src={calendarIcon} />
                    </InputRightElement>
                  )}
                </InputGroup>
                <SearchableSelectMulti
                  isShowSearch={true}
                  options={projects}
                  // initialSelectedOption={{ key: 0, value: "Chọn dự án" }}
                  placeholder={"Chọn dự án"}
                  setValue={setProjectId}
                />
              </Flex>
            </Flex>
          </Flex>
          <Box width={"100%"} height={"100%"}>
            <Skeleton isLoaded={!isLoading && !isRefetching}>
              <TableContainer
                w={"100%"}
                maxH="calc(100vh - 350.5px)"
                overflowY="auto"
              >
                <Table w={"100%"} variant="unstyled">
                  <Thead
                    position="sticky"
                    top="0"
                    zIndex="1"
                    w={"100%"}
                    h={"41px"}
                    color="white"
                    fontWeight="400"
                    backgroundColor="#F9FAFD"
                  >
                    <Tr h={{ base: "41px" }}>
                      {tableData.headers.map((e, index) => {
                        let width = "auto";
                        let textAlign = "auto";
                        if (e.key === "") {
                          width = "2%";
                          textAlign = "center";
                        } else if (e.key === "code") {
                          width = "5%";
                          textAlign = "start";
                        } else if (e.key === "name") {
                          width = "10%";
                          textAlign = "start";
                        } else if (e.key === "project") {
                          width = "25%";
                          textAlign = "start";
                        } else if (e.key === "product") {
                          width = "10%";
                          textAlign = "start";
                        } else {
                          width = "20%";
                          textAlign = "end";
                        }
                        return (
                          <Td
                            p={"16px 16px 8px 16px"}
                            key={index}
                            border={"none"}
                            color={"#51607B"}
                            fontSize={{ base: "14px" }}
                            w={width}
                          >
                            <Box textAlign={"center"} fontWeight={"bold"}>{e.label}</Box>
                          </Td>
                        );
                      })}
                    </Tr>
                  </Thead>
                  <Tbody w={"100%"} h={"100%"}>
                    {tableData.data?.length > 0 ? (
                      tableData.data?.map((e, rowIndex) => {
                        const items = { ...e };
                        delete items.id;
                        delete items.edit;
                        delete items.detail;
                        delete items.addProduct;
                        const keyValues = Object.keys(items);
                        return (
                          <Tr key={rowIndex} h={"72px"}>
                            <Td p={"16px 16px 8px 16px"} w={"2%"}>
                              <Menu>
                                <MenuButton
                                  _hover={{ backgroundColor: "none" }}
                                  _active={{ backgroundColor: "none" }}
                                  background="none"
                                  as={Button}
                                >
                                  <AiOutlineMore fontSize={"20px"} />
                                </MenuButton>
                                <MenuList
                                  fontSize={{ base: "14px" }}
                                  fontWeight={500}
                                  lineHeight={"140%"}
                                  color={"var(--color-info-employee)"}
                                >
                                  <MenuItem
                                    gap={"16px"}
                                    onClick={() => handlePopup(true, e)}
                                  >
                                    <Image src={iconEdit} /> Chỉnh sửa
                                  </MenuItem>
                                  <MenuItem
                                    gap={"16px"}
                                    onClick={() =>
                                      handlePopupAddProduct(false, e)
                                    }
                                  >
                                    <Image src={iconAdd} /> Thêm sản phẩm
                                  </MenuItem>
                                  <MenuItem
                                    gap={"16px"}
                                    onClick={() => handlePopupDelete(e)}
                                  >
                                    <Image src={icontrash} /> Xóa ĐN booking
                                  </MenuItem>
                                </MenuList>
                              </Menu>
                            </Td>
                            {keyValues.map((keyvalue, index) => {
                              let width = "auto";
                              let widthText = "100%";
                              let textAlign = "auto";
                              let whiteSpace = "inherit";
                              if (keyvalue === "") {
                                width = "2%";
                                textAlign = "center";
                              } else if (keyvalue === "code") {
                                width = "5%";
                                textAlign = "start";
                              } else if (keyvalue === "name") {
                                width = "10%";
                                textAlign = "start";
                              } else if (keyvalue === "project") {
                                width = "25%";
                                textAlign = "start";
                                whiteSpace = "normal";
                                widthText = "118px";
                              } else if (keyvalue === "product") {
                                width = "10%";
                                textAlign = "start";
                              } else {
                                width = "20%";
                                textAlign = "end";
                                whiteSpace = "inherit";
                              }
                              return (
                                <Td
                                  p={"16px 16px 8px 16px"}
                                  w={width}
                                  key={index}
                                >
                                  <Box
                                    fontSize={{ base: "14px" }}
                                    lineHeight={"19.6px"}
                                    textAlign={"start"}
                                    fontWeight={500}
                                    color={"var(--color-info-employee)"}
                                    w={widthText}
                                    whiteSpace={whiteSpace}
                                    overflow="hidden"
                                    textOverflow="ellipsis"
                                    display="-webkit-box"
                                    sx={{
                                      WebkitLineClamp: "2",
                                      WebkitBoxOrient: "vertical",
                                    }}
                                  >
                                    {formatTableValue(e[keyvalue], keyvalue)}
                                  </Box>
                                </Td>
                              );
                            })}
                          </Tr>
                        );
                      })
                    ) : (
                      <Tr>
                        <Td
                          colSpan={tableData.headers.length}
                          textAlign="center"
                          padding={"40px 0"}
                        >
                          Không có dữ liệu
                        </Td>
                      </Tr>
                    )}
                  </Tbody>
                </Table>
              </TableContainer>
            </Skeleton>
            <Box mt={10} mr={5} mb={5} ml={5}>
              <Flex alignItems={"center"} justifyContent={"space-between"}>
                <Text>
                  Showing {startEntry} to {endEntry} of {entries} entries
                </Text>
                <HStack spacing={2} justify="flex-end">
                  <ReactPaginate
                    className="pagination-custom"
                    pageCount={totalPages}
                    pageRangeDisplayed={3}
                    marginPagesDisplayed={1}
                    onPageChange={handlePageChange}
                    containerClassName={"pagination"}
                    activeClassName={"active"}
                    breakClassName={"ellipsis"}
                    breakLabel={"..."}
                    previousLabel={
                      <Img
                        w={"16px"}
                        minW={"16px"}
                        h={"16px"}
                        src={chevronLeft}
                      />
                    }
                    nextLabel={
                      <Img
                        w={"16px"}
                        minW={"16px"}
                        h={"16px"}
                        src={chevronRight}
                      />
                    }
                    renderOnZeroPageCount={null}
                    forcePage={currentPage - 1}
                  />
                </HStack>
              </Flex>
            </Box>
          </Box>
        </Flex>
      </Flex>
      {!popupDelete ? (
        isAddBooking ? (
          <AddBooking
            isOpen={isOpen}
            onClose={onClose}
            isEdit={true}
            defaultValues={dataEdit}
            onSubmit={onSubmitEdit}
          />
        ) : (
          <AddProduct
            isOpen={isOpen}
            onClose={onClose}
            isEdit={true}
            onSubmit={addProductBookingEvent}
            defaultValues={dataEdit}
          />
        )
      ) : (
        <DeleteDialog
          isOpen={isOpen}
          onClose={onClose}
          title="Xóa đợt nhận booking"
          description={
            <Flex display={"inline"}>
              "Bạn có chắc chắn muốn xóa đợt nhận booking{" "}
              <Text fontWeight={"600"} display={"inline"}>
                {dataEdit?.name}
              </Text>{" "}
              không?"
            </Flex>
          }
          action={() => onSubmitDelete()}
        />
      )}
    </>
  );
};

export default TableApartments;
